// from http://www.lukasjakob.com/how-to-dynamically-load-external-scripts-in-angular/
import { Injectable } from "@angular/core"

const myScripts = [
    {
        name: "videojs",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/video-7.10.2.min.js",
    },
    {
        name: "videojs.css",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/video-js-7.10.2.min.css",
    },
    {
        name: "videojs-mux",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-mux-3.1.3.js",
    },
    {
        name: "videojs-vr",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-vr-1.7.1.min.js",
    },
    {
        name: "videojs-errors",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-errors-4.3.2.min.js",
    },
    {
        name: "videojs-hotkeys",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs.hotkeys-0.2.27.min.js",
    },
    {
        name: "videojs-contrib-quality-levels",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-contrib-quality-levels-2.0.9.min.js",
    },
    {
        name: "videojs-http-source-selector",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-http-source-selector-1.1.6.min.js",
    },
    {
        name: "videojs-seek-buttons",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-seek-buttons-1.6.0.min.js",
    },
    {
        name: "wavesurfer",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/wavesurfer.min.js",
    },
    {
        name: "videojs-wavesurfer",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs.wavesurfer.min.js",
    },
    {
        name: "videojs-seek-chapter",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-seek-chapter/v2/videojs-seek-chapter.min.js",
    },
    {
        name: "videojs-seek-chapter.css",
        src: "https://d43fweuh3sg51.cloudfront.net/defaults/videojs-seek-chapter/v2/videojs-seek-chapter.css",
    },
    {
        name: "pinterest",
        src: "https://assets.pinterest.com/js/pinit.js",
    },
]

@Injectable({
    providedIn: "root",
})
export class ScriptService {
    private scripts: any = {}

    constructor() {
        myScripts.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src,
            }
        })
    }

    // load a single or multiple scripts
    public load(...scripts: string[]) {
        const promises: any[] = []
        // push the returned promise of each loadScript call
        scripts.forEach((script) => promises.push(this.loadScript(script)))
        // return promise.all that resolves when all promises are resolved
        return Promise.all(promises)
    }

    // load the script
    public loadScript(name: string) {
        return new Promise((resolve, reject) => {
            // resolve if already loaded
            if (this.scripts[name].loaded) {
                resolve({
                    script: name,
                    loaded: true,
                    status: "Already Loaded",
                })
            } else {
                // load script
                let element: any
                if (this.scripts[name].src.endsWith(".js")) {
                    element = document.createElement("script")
                    element.src = this.scripts[name].src
                    element.type = "text/javascript"
                } else if (this.scripts[name].src.endsWith(".css")) {
                    element = document.createElement("link")
                    element.rel = "stylesheet"
                    element.href = this.scripts[name].src
                }
                if (element.readyState) {
                    // IE
                    element.onreadystatechange = () => {
                        if (element.readyState === "loaded" || element.readyState === "complete") {
                            element.onreadystatechange = null
                            this.scripts[name].loaded = true
                            resolve({
                                script: name,
                                loaded: true,
                                status: "Loaded",
                            })
                        }
                    }
                } else {
                    // Others
                    element.onload = () => {
                        this.scripts[name].loaded = true
                        resolve({
                            script: name,
                            loaded: true,
                            status: "Loaded",
                        })
                    }
                }
                element.onerror = (error: any) =>
                    resolve({ script: name, loaded: false, status: "Loaded" })
                // finally append the script tag in the DOM
                document.getElementsByTagName("head")[0].appendChild(element)
            }
        })
    }
}
